import { useAvatars, normalizeName } from '../lib/avatars.tsx';

/**
 * A manager's avatar, looked up by name. Falls back to their initials on a
 * burnt-orange chip when no picture has been uploaded.
 */
export function Avatar({ name, size = 40 }: { name: string; size?: number }) {
  const { map } = useAvatars();
  const src = map[normalizeName(name)];
  const initials = name
    .split(' ')
    .map((p) => p[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();

  const style = { width: size, height: size };

  if (src) {
    return (
      <img
        src={src}
        alt={name}
        style={style}
        className="shrink-0 rounded-full object-cover"
      />
    );
  }
  return (
    <div
      style={style}
      className="flex shrink-0 items-center justify-center rounded-full bg-brass/20 font-display text-xs font-bold text-brass"
    >
      {initials}
    </div>
  );
}
